// Import jQuery from npm and set as window globals.
// This overwrites the synchronously-loaded jQuery (from <script> in layout).
// The synchronous jQuery exists only so inline <script> tags in views work
// before Vite modules load. Once Vite loads, this npm jQuery becomes the
// single instance for all plugins (jQuery UI, Bootstrap, select2, etc.).
import jQuery from 'jquery';
window.$ = window.jQuery = jQuery;
export default jQuery;
